const BUSINESS_EMAIL = "Thebridgecollectivellc@gmail.com";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#040404] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="/tbc-logo.jpeg"
                alt="The Bridge Collective"
                className="h-10 w-10 object-contain"
                style={{ filter: "invert(1) brightness(1.05) contrast(1.1)" }}
              />
              <div className="flex flex-col leading-tight">
                <span className="font-display tracking-[0.28em] text-white text-xs font-light">
                  THE BRIDGE
                </span>
                <span className="font-display tracking-[0.28em] text-[#1A5C40] text-xs font-light">
                  COLLECTIVE
                </span>
              </div>
            </div>
            <p className="mt-5 text-sm text-zinc-500 leading-relaxed max-w-sm">
              Serious organizations trust serious protection. Discreet,
              tailored, and uncompromising private security across the DMV,
              Baltimore, and the state of Maryland.
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-4">Contact</div>
            <a
              href={`mailto:${BUSINESS_EMAIL}?subject=The%20Bridge%20Collective%20Inquiry`}
              data-testid="footer-email"
              className="text-sm text-zinc-300 hover:text-white transition-colors break-all"
            >
              {BUSINESS_EMAIL}
            </a>
            <p className="mt-3 text-xs text-zinc-600 tracking-[0.18em] uppercase">
              By email — by design.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4">Coverage</div>
            <p className="text-sm text-zinc-400 leading-relaxed">
              DMV Area
              <br />
              Baltimore
              <br />
              State of Maryland
            </p>
          </div>
        </div>

        <div className="bubaloo-divider my-10" />

        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 text-xs text-zinc-600">
          <div>© {year} The Bridge Collective LLC. All rights reserved.</div>
          <div className="tracking-[0.22em] uppercase">
            Protection · Discretion · Authority
          </div>
        </div>
      </div>
    </footer>
  );
}
